import { Fragment, useState, useEffect } from 'react'
import { useDispatch, useSelector, shallowEqual } from 'react-redux'
import { useModal } from '@leroy-merlin-br/backyard-react-ui'

import { Actions } from 'lmcv/redux/modules/profile'

import Banner from './Banner'
import Form from './Form'

const Preferences = () => {
  const dispatch = useDispatch()
  const { payload, isRequest } = useSelector(
    state => state.profile.get,
    shallowEqual
  )
  const { setModal } = useModal()

  const formModal = () => {
    return setModal({
      appElement: 'body',
      hasScroll: 'true',
      size: 'giga',
      children: ({ onClose }) => (
        <Form onClose={onClose} preferencesData={payload.data.interests} />
      )
    })
  }

  useEffect(() => {
    dispatch(Actions.getProfile())
  }, [dispatch])

  return (
    <Fragment>
      {!isRequest && (
        <Fragment>
          <Banner onClick={formModal} />
        </Fragment>
      )}
    </Fragment>
  )
}

export default Preferences
